import React, { useState, useMemo, useEffect } from "react";
import Checklist from "../Checklist";

const UserAddOnSection = (props) => {
  const [addOnsCheckboxes, setAddOnsCheckboxes] = useState([]);
  const { mode, requestType, user, setUser } = props;

  const addOns = useMemo(
    () =>
      [
        requestType === "AddKCUser" || requestType === "AddHomeOfficeUser" || mode === "update"
          ? [
              { label: "Does this user need Monitors?", fieldName: "needsMonitors" },
              { label: "Does this user need a Desk Phone?", fieldName: "needsDeskPhone" },
              { label: "Does this user need a Headset?", fieldName: "needsHeadset" },
              { label: "Does this user need a Cell Phone?", fieldName: "needsCellPhone" },
            ]
          : [],
        requestType == "AddHomeOfficeUser"
          ? [
              { label: "Does this user need City Wide You Admin?", fieldName: "cityWideYouAdmin" },
              { label: "Does this user need Acrobat Pro?", fieldName: "acrobatPro" },
              { label: "Does this user need HubStaff?", fieldName: "hubStaff" },
              { label: "Does this user need Zendesk Agent?", fieldName: "zendeskAgent" },
              { label: "Does this user need Adobe Creative Cloud?", fieldName: "adobeCreativeCloud" },
              { label: "Does this user need Max Agent?", fieldName: "maxAgent" },
            ]
          : [],
      ]
        .flat()
        .filter((addOnGroup) => addOnGroup.length !== 0),
    [requestType, mode]
  );

  useEffect(() => {
    if (addOns) {
      const formattedAddOns = addOns.map((addOn) => ({
        label: addOn.label,
        onClick: () =>
          setUser((prevUser) => ({
            ...prevUser,
            [addOn.fieldName]: user[addOn.fieldName],
          })),
        checked: user[addOn.fieldName],
      }));
      setAddOnsCheckboxes(formattedAddOns);
    }
  }, [addOns, user, requestType, setUser]);

  return (
    <>
      {addOnsCheckboxes.length > 0 ? (
        <div className="my-3" style={{ display: "flex", flexDirection: "column" }}>
          Select Other User Needs
          <Checklist checkboxes={addOnsCheckboxes} />
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default UserAddOnSection;
